import React, { useMemo } from 'react';
import classnames from 'classnames';
import CheckBoxList from '../CheckBoxList';
import '@intelligence/components/GenreSelect/components/CheckboxbarPanel/index.scss';
import { isEmpty } from 'lodash-es';

/**
 * 批量操作按钮状态（Select All/Clear All）
 * -1 不展示批量操作按钮
 * 0 展示Clear All按钮
 * 1 展示Select All按钮
 */
export type IBatchOperation = -1 | 0 | 1;

interface ICheckboxbarPanelProps {
  className?: string;
  checkboxListClassName?: string;
  title?: string;
  search?: string;
  levelList: any[];
  parentList: any[];
  onOperation?: (showSelectAll: boolean, activeParent: any) => void;
  onChange?: (payload: any) => void;
  onClick?: (payload: any) => void;
}

const CheckBoxPanel: React.FC<ICheckboxbarPanelProps> = (props) => {
  const { className, checkboxListClassName, onChange, onClick, onOperation, levelList, parentList, search, title } =
    props;

  // 根据选中父级,展示此子级数据
  const activeParent = useMemo(() => {
    let activeParentTemp = {} as any;
    if (!isEmpty(parentList)) {
      const active = parentList?.find((item: any) => item.active === true) || {};
      if (isEmpty(active)) {
        // eslint-disable-next-line prefer-destructuring
        activeParentTemp = parentList[0];
      } else {
        activeParentTemp = active;
      }
    }
    return activeParentTemp;
  }, [levelList, parentList]);

  // 根据选中父级,展示此子级数据
  const levelListCur = useMemo(() => {
    let projectList = [];
    if (!isEmpty(activeParent)) {
      projectList = levelList?.filter((item: any) => item.parentId === activeParent?.id) || [];
    } else {
      projectList = [...levelList];
    }
    return projectList;
  }, [levelList, activeParent]);

  const isNoData = useMemo(() => {
    return !Array.isArray(levelListCur) || !levelListCur?.length;
  }, [levelListCur]);

  // 父级选中数据
  const showSelectAll = useMemo(() => {
    return levelListCur.every((item: any) => item.state === 'all');
  }, [levelListCur]);

  return (
    <div className={classnames('genre-select-panel-item', className)}>
      <div className="panel-topbar">
        <span className="panel-title">{title}</span>
        {!isNoData && (
          <a
            className="panel-operation"
            onClick={(e) => {
              e.stopPropagation();
              // 展示Select All时，点击就是要全选，反之取消全选
              onOperation?.(showSelectAll, activeParent);
            }}
          >
            {!showSelectAll ? 'Select All' : 'Clear All'}
          </a>
        )}
      </div>
      <CheckBoxList
        checkboxListClassName={checkboxListClassName}
        levelList={levelListCur}
        onChange={onChange}
        onClick={onClick}
        search={search}
        isNoData={isNoData}
      />
    </div>
  );
};

export default CheckBoxPanel;
